import global from '../general/global';

export default {
    initializeSwiper: function () {
        let locationsSwiper;

        if(jQuery(window).width() < 768) {
            jQuery('.js-locations--swiper').addClass('swiper');
            jQuery('.js-locations--swiper-wrapper').addClass('swiper-wrapper');
            jQuery('.js-locations--swiper-slide').addClass('swiper-slide');

            if (!global.swiperLoaded) {
                loadjs([menaObject.assets + '/js/swiper.min.js', menaObject.assets + '/css/swiper.css'], function () {
                    locationsSwiper = new Swiper('.js-locations--swiper', {
                        slidesPerView: 1.15,
                        centeredSlides: true,
                        navigation: {
                            nextEl: '.js-locations--swiper-next',
                            prevEl: '.js-locations--swiper-prev',
                        },
                        spaceBetween: 5,
                    });
    
                    global.swiperLoaded = true;
                });
            } else {
                locationsSwiper = new Swiper('.js-locations--swiper', {
                    slidesPerView: 1.5,
                    centeredSlides: true,
                    navigation: {
                        nextEl: '.js-locations--swiper-next',
                        prevEl: '.js-locations--swiper-prev',
                    },
                    spaceBetween: 5,
                });
            }
        }
    },
};
